import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { OnoffType } from '@/api/enum/common.enum';
import { ActivityFilter } from '@/api/DTO/task/activity.interface';
import { PUBLISHED_LISTB } from '@/common/constants/common';

export default function ActivitySummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<ActivityFilter>();
	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='publishedList'
					label={t('taskManage.taskStatus')}
					options={PUBLISHED_LISTB}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
		</Grid>
	);
}
